import { render, staticRenderFns } from "./inquiryContent.vue?vue&type=template&id=bc6307a6&scoped=true&"
import script from "./inquiryContent.vue?vue&type=script&lang=js&"
export * from "./inquiryContent.vue?vue&type=script&lang=js&"
import style0 from "./inquiryContent.vue?vue&type=style&index=0&id=bc6307a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6307a6",
  null
  
)

export default component.exports